import { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

import type { AppRoute } from './config';

interface AppRouterProps {
  routes: Record<string, AppRoute> | AppRoute[];
}

export const AppRouter = ({ routes }: AppRouterProps) => {
  const routesArray = Array.isArray(routes) ? routes : Object.values(routes);

  return (
    <Suspense fallback={null}>
      <Routes>
        {routesArray.map(({ element, path }) => (
          <Route key={path} path={path} element={element} />
        ))}
      </Routes>
    </Suspense>
  );
};
